/* Copyright 2013 - 2024 Waiterio LLC */
/* eslint-disable comma-dangle, quote-props, quotes */

export default [
  { countryCode: 'DE', city: 'Berlin', name: '10115' },
  { countryCode: 'DE', city: 'Berlin', name: '10117' },
  { countryCode: 'DE', city: 'Berlin', name: '10119' },
  { countryCode: 'DE', city: 'Berlin', name: '10407' },
  { countryCode: 'DE', city: 'Berlin', name: '10437' },
  { countryCode: 'DE', city: 'Berlin', name: '10551' },
  { countryCode: 'DE', city: 'Berlin', name: '10553' },
  { countryCode: 'DE', city: 'Berlin', name: '10557' },
  { countryCode: 'DE', city: 'Berlin', name: '10585' },
  { countryCode: 'DE', city: 'Berlin', name: '10627' },
  { countryCode: 'DE', city: 'Berlin', name: '10707' },
  { countryCode: 'DE', city: 'Berlin', name: '10781' },
  { countryCode: 'DE', city: 'Berlin', name: '10823' },
  { countryCode: 'DE', city: 'Berlin', name: '10961' },
  { countryCode: 'DE', city: 'Berlin', name: '10968' },
  { countryCode: 'DE', city: 'Berlin', name: '10999' },
  { countryCode: 'DE', city: 'Berlin', name: '12049' },
  { countryCode: 'DE', city: 'Berlin', name: '12051' },
  { countryCode: 'DE', city: 'Berlin', name: '12099' },
  { countryCode: 'DE', city: 'Berlin', name: '12161' },
  { countryCode: 'DE', city: 'Berlin', name: '12378' },
  { countryCode: 'DE', city: 'Berlin', name: '12437' },
  { countryCode: 'DE', city: 'Berlin', name: '12489' },
  { countryCode: 'DE', city: 'Berlin', name: '12683' },
  { countryCode: 'DE', city: 'Berlin', name: '13088' },
  { countryCode: 'DE', city: 'Berlin', name: '13125' },
  { countryCode: 'DE', city: 'Berlin', name: '13127' },
  { countryCode: 'DE', city: 'Berlin', name: '13353' },
  { countryCode: 'DE', city: 'Berlin', name: '13407' },
  { countryCode: 'DE', city: 'Berlin', name: '13585' },
  { countryCode: 'DE', city: 'Berlin', name: '13589' },
  { countryCode: 'DE', city: 'Berlin', name: '14089' },

  { countryCode: 'ES', city: 'Barcelona', name: '08001' },
  { countryCode: 'ES', city: 'Barcelona', name: '08002' },
  { countryCode: 'ES', city: 'Barcelona', name: '08003' },
  { countryCode: 'ES', city: 'Barcelona', name: '08004' },
  { countryCode: 'ES', city: 'Barcelona', name: '08006' },
  { countryCode: 'ES', city: 'Barcelona', name: '08008' },
  { countryCode: 'ES', city: 'Barcelona', name: '08009' },
  { countryCode: 'ES', city: 'Barcelona', name: '08011' },
  { countryCode: 'ES', city: 'Barcelona', name: '08012' },
  { countryCode: 'ES', city: 'Barcelona', name: '08016' },
  { countryCode: 'ES', city: 'Barcelona', name: '08018' },
  { countryCode: 'ES', city: 'Barcelona', name: '08021' },
  { countryCode: 'ES', city: 'Barcelona', name: '08023' },
  { countryCode: 'ES', city: 'Barcelona', name: '08026' },
  { countryCode: 'ES', city: 'Barcelona', name: '08027' },
  { countryCode: 'ES', city: 'Barcelona', name: '08028' },
  { countryCode: 'ES', city: 'Barcelona', name: '08029' },
  { countryCode: 'ES', city: 'Barcelona', name: '08030' },
  { countryCode: 'ES', city: 'Barcelona', name: '08031' },
  { countryCode: 'ES', city: 'Barcelona', name: '08032' },
  { countryCode: 'ES', city: 'Barcelona', name: '08033' },
  { countryCode: 'ES', city: 'Barcelona', name: '08035' },
  { countryCode: 'ES', city: 'Barcelona', name: '08036' },
  { countryCode: 'ES', city: 'Barcelona', name: '08038' },
  { countryCode: 'ES', city: 'Barcelona', name: '08041' },
  { countryCode: 'ES', city: 'Barcelona', name: '08191' },
  { countryCode: 'ES', city: 'Barcelona', name: '08402' },
  { countryCode: 'ES', city: 'Barcelona', name: '08902' },
  { countryCode: 'ES', city: 'Barcelona', name: '08905' },
  { countryCode: 'ES', city: 'Barcelona', name: '08906' },
  { countryCode: 'ES', city: 'Barcelona', name: '08922' },

  { countryCode: 'ES', city: 'Madrid', name: '28000' },
  { countryCode: 'ES', city: 'Madrid', name: '28001' },
  { countryCode: 'ES', city: 'Madrid', name: '28002' },
  { countryCode: 'ES', city: 'Madrid', name: '28003' },
  { countryCode: 'ES', city: 'Madrid', name: '28004' },
  { countryCode: 'ES', city: 'Madrid', name: '28006' },
  { countryCode: 'ES', city: 'Madrid', name: '28010' },
  { countryCode: 'ES', city: 'Madrid', name: '28011' },
  { countryCode: 'ES', city: 'Madrid', name: '28012' },
  { countryCode: 'ES', city: 'Madrid', name: '28013' },
  { countryCode: 'ES', city: 'Madrid', name: '28014' },
  { countryCode: 'ES', city: 'Madrid', name: '28015' },
  { countryCode: 'ES', city: 'Madrid', name: '28022' },
  { countryCode: 'ES', city: 'Madrid', name: '28025' },
  { countryCode: 'ES', city: 'Madrid', name: '28026' },
  { countryCode: 'ES', city: 'Madrid', name: '28027' },
  { countryCode: 'ES', city: 'Madrid', name: '28028' },
  { countryCode: 'ES', city: 'Madrid', name: '28029' },
  { countryCode: 'ES', city: 'Madrid', name: '28030' },
  { countryCode: 'ES', city: 'Madrid', name: '28031' },
  { countryCode: 'ES', city: 'Madrid', name: '28033' },
  { countryCode: 'ES', city: 'Madrid', name: '28035' },
  { countryCode: 'ES', city: 'Madrid', name: '28037' },
  { countryCode: 'ES', city: 'Madrid', name: '28039' },
  { countryCode: 'ES', city: 'Madrid', name: '28040' },
  { countryCode: 'ES', city: 'Madrid', name: '28054' },
  { countryCode: 'ES', city: 'Madrid', name: '28108' },
  { countryCode: 'ES', city: 'Madrid', name: '28210' },
  { countryCode: 'ES', city: 'Madrid', name: '28231' },
  { countryCode: 'ES', city: 'Madrid', name: '28522' },
  { countryCode: 'ES', city: 'Madrid', name: '28529' },
  { countryCode: 'ES', city: 'Madrid', name: '28899' },
  { countryCode: 'ES', city: 'Madrid', name: '28922' },
  { countryCode: 'ES', city: 'Madrid', name: '28942' },

  { countryCode: 'ES', city: 'Málaga', name: '29001' },
  { countryCode: 'ES', city: 'Málaga', name: '29002' },
  { countryCode: 'ES', city: 'Málaga', name: '29004' },
  { countryCode: 'ES', city: 'Málaga', name: '29006' },
  { countryCode: 'ES', city: 'Málaga', name: '29007' },
  { countryCode: 'ES', city: 'Málaga', name: '29008' },
  { countryCode: 'ES', city: 'Málaga', name: '29010' },
  { countryCode: 'ES', city: 'Málaga', name: '29011' },
  { countryCode: 'ES', city: 'Málaga', name: '29016' },
  { countryCode: 'ES', city: 'Málaga', name: '29130' },
  { countryCode: 'ES', city: 'Málaga', name: '29510' },
  { countryCode: 'ES', city: 'Málaga', name: '29552' },
  { countryCode: 'ES', city: 'Málaga', name: '29560' },
  { countryCode: 'ES', city: 'Málaga', name: '29570' },
  { countryCode: 'ES', city: 'Málaga', name: '29620' },
  { countryCode: 'ES', city: 'Málaga', name: '29631' },
  { countryCode: 'ES', city: 'Málaga', name: '29770' },
  { countryCode: 'ES', city: 'Málaga', name: '29793' },

  { countryCode: 'ES', city: 'Sevilla', name: '41002' },
  { countryCode: 'ES', city: 'Sevilla', name: '41003' },
  { countryCode: 'ES', city: 'Sevilla', name: '41005' },
  { countryCode: 'ES', city: 'Sevilla', name: '41006' },
  { countryCode: 'ES', city: 'Sevilla', name: '41007' },
  { countryCode: 'ES', city: 'Sevilla', name: '41008' },
  { countryCode: 'ES', city: 'Sevilla', name: '41010' },
  { countryCode: 'ES', city: 'Sevilla', name: '41011' },
  { countryCode: 'ES', city: 'Sevilla', name: '41012' },
  { countryCode: 'ES', city: 'Sevilla', name: '41012 ' },
  { countryCode: 'ES', city: 'Sevilla', name: '41013' },
  { countryCode: 'ES', city: 'Sevilla', name: '41014' },
  { countryCode: 'ES', city: 'Sevilla', name: '41015' },
  { countryCode: 'ES', city: 'Sevilla', name: '41019' },
  { countryCode: 'ES', city: 'Sevilla', name: '41020' },
  { countryCode: 'ES', city: 'Sevilla', name: '41460' },
  { countryCode: 'ES', city: 'Sevilla', name: '41560' },
  { countryCode: 'ES', city: 'Sevilla', name: '41670' },
  { countryCode: 'ES', city: 'Sevilla', name: '41702' },
  { countryCode: 'ES', city: 'Sevilla', name: '41731' },
  { countryCode: 'ES', city: 'Sevilla', name: '41806' },
  { countryCode: 'ES', city: 'Sevilla', name: '41807' },
  { countryCode: 'ES', city: 'Sevilla', name: '41927' },
  { countryCode: 'ES', city: 'Sevilla', name: '41928' },

  { countryCode: 'ES', city: 'Valencia', name: '46003' },
  { countryCode: 'ES', city: 'Valencia', name: '46006' },
  { countryCode: 'ES', city: 'Valencia', name: '46007' },
  { countryCode: 'ES', city: 'Valencia', name: '46008' },
  { countryCode: 'ES', city: 'Valencia', name: '46009' },
  { countryCode: 'ES', city: 'Valencia', name: '46011' },
  { countryCode: 'ES', city: 'Valencia', name: '46013' },
  { countryCode: 'ES', city: 'Valencia', name: '46014' },
  { countryCode: 'ES', city: 'Valencia', name: '46017' },
  { countryCode: 'ES', city: 'Valencia', name: '46018' },
  { countryCode: 'ES', city: 'Valencia', name: '46021' },
  { countryCode: 'ES', city: 'Valencia', name: '46022' },
  { countryCode: 'ES', city: 'Valencia', name: '46023' },
  { countryCode: 'ES', city: 'Valencia', name: '46025' },
  { countryCode: 'ES', city: 'Valencia', name: '46183' },
  { countryCode: 'ES', city: 'Valencia', name: '46600' },
  { countryCode: 'ES', city: 'Valencia', name: '46669' },
  { countryCode: 'ES', city: 'Valencia', name: '46760' },
  { countryCode: 'ES', city: 'Valencia', name: '46980' },

  { countryCode: 'HU', city: 'Budapest', name: '1025' },
  { countryCode: 'HU', city: 'Budapest', name: '1048' },
  { countryCode: 'HU', city: 'Budapest', name: '1055' },
  { countryCode: 'HU', city: 'Budapest', name: '1067' },
  { countryCode: 'HU', city: 'Budapest', name: '1068' },
  { countryCode: 'HU', city: 'Budapest', name: '1073' },
  { countryCode: 'HU', city: 'Budapest', name: '1076' },
  { countryCode: 'HU', city: 'Budapest', name: '1083' },
  { countryCode: 'HU', city: 'Budapest', name: '1085' },
  { countryCode: 'HU', city: 'Budapest', name: '1095' },
  { countryCode: 'HU', city: 'Budapest', name: '1105' },
  { countryCode: 'HU', city: 'Budapest', name: '1134' },
  { countryCode: 'HU', city: 'Budapest', name: '1144' },
  { countryCode: 'HU', city: 'Budapest', name: '1164' },

  { countryCode: 'IN', city: 'Kolkata', name: '700032' },
  { countryCode: 'IN', city: 'Kolkata', name: '700053' },
  { countryCode: 'IN', city: 'Kolkata', name: '712233' },
  { countryCode: 'IN', city: 'Kolkata', name: '743133' },

  { countryCode: 'IT', city: 'Bologna', name: '40122' },
  { countryCode: 'IT', city: 'Bologna', name: '40128' },
  { countryCode: 'IT', city: 'Bologna', name: '40131' },
  { countryCode: 'IT', city: 'Bologna', name: '40132' },
  { countryCode: 'IT', city: 'Bologna', name: '40139' },
  { countryCode: 'IT', city: 'Bologna', name: '40141' },

  { countryCode: 'IT', city: 'Firenze', name: '50123' },
  { countryCode: 'IT', city: 'Firenze', name: '50125' },

  { countryCode: 'IT', city: 'Genova', name: '16121' },
  { countryCode: 'IT', city: 'Genova', name: '16122' },
  { countryCode: 'IT', city: 'Genova', name: '16151' },
  { countryCode: 'IT', city: 'Genova', name: '16165' },

  { countryCode: 'IT', city: 'Milano', name: '20019' },
  { countryCode: 'IT', city: 'Milano', name: '20045' },
  { countryCode: 'IT', city: 'Milano', name: '20100' },
  { countryCode: 'IT', city: 'Milano', name: '20121' },
  { countryCode: 'IT', city: 'Milano', name: '20123' },
  { countryCode: 'IT', city: 'Milano', name: '20125' },
  { countryCode: 'IT', city: 'Milano', name: '20132' },
  { countryCode: 'IT', city: 'Milano', name: '20134' },
  { countryCode: 'IT', city: 'Milano', name: '20142' },
  { countryCode: 'IT', city: 'Milano', name: '20149' },
  { countryCode: 'IT', city: 'Milano', name: '20151' },
  { countryCode: 'IT', city: 'Milano', name: '20154' },
  { countryCode: 'IT', city: 'Milano', name: '20157' },
  { countryCode: 'IT', city: 'Milano', name: '20158' },
  { countryCode: 'IT', city: 'Milano', name: '20161' },
  { countryCode: 'IT', city: 'Milano', name: '20451' },

  { countryCode: 'IT', city: 'Napoli', name: '80034' },
  { countryCode: 'IT', city: 'Napoli', name: '80038' },
  { countryCode: 'IT', city: 'Napoli', name: '80090' },
  { countryCode: 'IT', city: 'Napoli', name: '80123' },
  { countryCode: 'IT', city: 'Napoli', name: '80125' },
  { countryCode: 'IT', city: 'Napoli', name: '80126' },
  { countryCode: 'IT', city: 'Napoli', name: '80128' },
  { countryCode: 'IT', city: 'Napoli', name: '80129' },
  { countryCode: 'IT', city: 'Napoli', name: '80134' },
  { countryCode: 'IT', city: 'Napoli', name: '80136' },
  { countryCode: 'IT', city: 'Napoli', name: '80143' },
  { countryCode: 'IT', city: 'Napoli', name: '80144' },

  { countryCode: 'IT', city: 'Palermo', name: '90100' },
  { countryCode: 'IT', city: 'Palermo', name: '90125' },
  { countryCode: 'IT', city: 'Palermo', name: '90127' },
  { countryCode: 'IT', city: 'Palermo', name: '90129' },
  { countryCode: 'IT', city: 'Palermo', name: '90139' },
  { countryCode: 'IT', city: 'Palermo', name: '90141' },
  { countryCode: 'IT', city: 'Palermo', name: '90147' },

  { countryCode: 'IT', city: 'Roma', name: '00100' },
  { countryCode: 'IT', city: 'Roma', name: '00121' },
  { countryCode: 'IT', city: 'Roma', name: '00122' },
  { countryCode: 'IT', city: 'Roma', name: '00123' },
  { countryCode: 'IT', city: 'Roma', name: '00124' },
  { countryCode: 'IT', city: 'Roma', name: '00132' },
  { countryCode: 'IT', city: 'Roma', name: '00135' },
  { countryCode: 'IT', city: 'Roma', name: '00136' },
  { countryCode: 'IT', city: 'Roma', name: '00137' },
  { countryCode: 'IT', city: 'Roma', name: '00139' },
  { countryCode: 'IT', city: 'Roma', name: '00141' },
  { countryCode: 'IT', city: 'Roma', name: '00142' },
  { countryCode: 'IT', city: 'Roma', name: '00144' },
  { countryCode: 'IT', city: 'Roma', name: '00145' },
  { countryCode: 'IT', city: 'Roma', name: '00146' },
  { countryCode: 'IT', city: 'Roma', name: '00149' },
  { countryCode: 'IT', city: 'Roma', name: '00151' },
  { countryCode: 'IT', city: 'Roma', name: '00152' },
  { countryCode: 'IT', city: 'Roma', name: '00153' },
  { countryCode: 'IT', city: 'Roma', name: '00154' },
  { countryCode: 'IT', city: 'Roma', name: '00156' },
  { countryCode: 'IT', city: 'Roma', name: '00161' },
  { countryCode: 'IT', city: 'Roma', name: '00162' },
  { countryCode: 'IT', city: 'Roma', name: '00165' },
  { countryCode: 'IT', city: 'Roma', name: '00166' },
  { countryCode: 'IT', city: 'Roma', name: '00167' },
  { countryCode: 'IT', city: 'Roma', name: '00171' },
  { countryCode: 'IT', city: 'Roma', name: '00172' },
  { countryCode: 'IT', city: 'Roma', name: '00175' },
  { countryCode: 'IT', city: 'Roma', name: '00176' },
  { countryCode: 'IT', city: 'Roma', name: '00177' },
  { countryCode: 'IT', city: 'Roma', name: '00178' },
  { countryCode: 'IT', city: 'Roma', name: '00179' },
  { countryCode: 'IT', city: 'Roma', name: '00181' },
  { countryCode: 'IT', city: 'Roma', name: '00182' },
  { countryCode: 'IT', city: 'Roma', name: '00183' },
  { countryCode: 'IT', city: 'Roma', name: '00184' },
  { countryCode: 'IT', city: 'Roma', name: '00185' },
  { countryCode: 'IT', city: 'Roma', name: '00186' },
  { countryCode: 'IT', city: 'Roma', name: '00187' },
  { countryCode: 'IT', city: 'Roma', name: '00189' },
  { countryCode: 'IT', city: 'Roma', name: '00191' },
  { countryCode: 'IT', city: 'Roma', name: '00192' },
  { countryCode: 'IT', city: 'Roma', name: '00193' },
  { countryCode: 'IT', city: 'Roma', name: '00195' },
  { countryCode: 'IT', city: 'Roma', name: '00196' },
  { countryCode: 'IT', city: 'Roma', name: '00197' },
  { countryCode: 'IT', city: 'Roma', name: '00198' },
  { countryCode: 'IT', city: 'Roma', name: '00199' },

  { countryCode: 'IT', city: 'Torino', name: '10121' },
  { countryCode: 'IT', city: 'Torino', name: '10122' },
  { countryCode: 'IT', city: 'Torino', name: '10123' },
  { countryCode: 'IT', city: 'Torino', name: '10133' },
  { countryCode: 'IT', city: 'Torino', name: '10139' },
  { countryCode: 'IT', city: 'Torino', name: '10144' },
  { countryCode: 'IT', city: 'Torino', name: '10152' },
  { countryCode: 'IT', city: 'Torino', name: '10154' },
  { countryCode: 'IT', city: 'Torino', name: '10155' },

  { countryCode: 'MX', city: 'Chihuahua', name: '31000' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31060' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31100' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31124' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31125' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31150' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31203' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31205' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31210' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31214' },
  { countryCode: 'MX', city: 'Chihuahua', name: '31375' },

  { countryCode: 'MX', city: 'Ciudad de México', name: '01030' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '01080' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '01120' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '01400' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '01460' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '01470' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '01840' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '02080' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '02140' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '02800' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '03100' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '03300' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '03303' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '03650' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '03810' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '03930' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '04240' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '04369' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '04470' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '04480' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '04600' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '04610' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '04650' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '04890' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '05300' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '06010' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '06100' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '06470' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '06500' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '06600' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '06700' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '06760' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '07230' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '07300' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '07420' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '07500' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '07660' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '07750' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '07800' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '08700' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '08900' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09080' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09140' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09210' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09230' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09310' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09500' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09510' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09700' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09720' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09819' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09830' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '09860' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '10010' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '10400' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '11000' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '11300' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '11320' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '11550' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '11560' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '11800' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '11880' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '12000' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '13000' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '14000' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '14160' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '14200' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '14370' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '14650' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '15600' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '15700' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '15860' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '15900' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '16010' },
  { countryCode: 'MX', city: 'Ciudad de México', name: '16020' },

  { countryCode: 'MX', city: 'Guadalajara', name: '44100' },
  { countryCode: 'MX', city: 'Guadalajara', name: '44130' },
  { countryCode: 'MX', city: 'Guadalajara', name: '44160' },
  { countryCode: 'MX', city: 'Guadalajara', name: '44270' },
  { countryCode: 'MX', city: 'Guadalajara', name: '44340' },
  { countryCode: 'MX', city: 'Guadalajara', name: '44360' },
  { countryCode: 'MX', city: 'Guadalajara', name: '44600' },
  { countryCode: 'MX', city: 'Guadalajara', name: '44620' },
  { countryCode: 'MX', city: 'Guadalajara', name: '44860' },
  { countryCode: 'MX', city: 'Guadalajara', name: '45050' },
  { countryCode: 'MX', city: 'Guadalajara', name: '45079' },
  { countryCode: 'MX', city: 'Guadalajara', name: '45130' },
  { countryCode: 'MX', city: 'Guadalajara', name: '45645' },
  { countryCode: 'MX', city: 'Guadalajara', name: '45930' },

  { countryCode: 'MX', city: 'Mérida', name: '97000' },
  { countryCode: 'MX', city: 'Mérida', name: '97128' },
  { countryCode: 'MX', city: 'Mérida', name: '97134' },
  { countryCode: 'MX', city: 'Mérida', name: '97150' },
  { countryCode: 'MX', city: 'Mérida', name: '97165' },
  { countryCode: 'MX', city: 'Mérida', name: '97180' },
  { countryCode: 'MX', city: 'Mérida', name: '97203' },
  { countryCode: 'MX', city: 'Mérida', name: '97219' },
  { countryCode: 'MX', city: 'Mérida', name: '97229' },
  { countryCode: 'MX', city: 'Mérida', name: '97302' },
  { countryCode: 'MX', city: 'Mérida', name: '97314' },
  { countryCode: 'MX', city: 'Mérida', name: '97390' },

  { countryCode: 'MX', city: 'Monterrey', name: '64000' },
  { countryCode: 'MX', city: 'Monterrey', name: '64102' },
  { countryCode: 'MX', city: 'Monterrey', name: '64108' },
  { countryCode: 'MX', city: 'Monterrey', name: '64120' },
  { countryCode: 'MX', city: 'Monterrey', name: '64310' },
  { countryCode: 'MX', city: 'Monterrey', name: '64340' },
  { countryCode: 'MX', city: 'Monterrey', name: '64630' },
  { countryCode: 'MX', city: 'Monterrey', name: '64640' },
  { countryCode: 'MX', city: 'Monterrey', name: '64700' },
  { countryCode: 'MX', city: 'Monterrey', name: '64720' },
  { countryCode: 'MX', city: 'Monterrey', name: '64998' },
  { countryCode: 'MX', city: 'Monterrey', name: '66646' },
  { countryCode: 'MX', city: 'Monterrey', name: '67423' },

  { countryCode: 'PK', city: 'Karachi', name: '75500' },
  { countryCode: 'PK', city: 'Karachi', name: '75950' },
]
